import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Testimonial from "./components/Testimonial";
import ContactInfo from "./components/ContactInfo";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";
import PopupForm from "./components/PopupForm";

function App() {
  return (
    <>
      {/* ✅ POPUP (ONLY ONCE) */}
      <PopupForm />

      {/* ✅ NAVBAR */}
      <Navbar />

      {/* ✅ SECTIONS */}
      <section id="home"><Home /></section>
      <section id="about"><About /></section>
      <section id="services"><Services /></section>
      <section id="faq"><FAQ /></section>

      <Testimonial />

      <section id="contact"><Contact /></section>

      <ContactInfo />
      <Footer />
      <FloatingContact />
    </>
  );
}

export default App;